import React from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import {Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel,
} from 'react-accessible-accordion';
import '../../components/react-accessible-accordion-mystyle.css';
import Button from "../../components/Button";
import {Container, Part1Exposition, Part1Content} from "./VIntroContent";



function VIntro() {
	return (
	<Container>
		<div style={{textAlign: "center", clear:"both"}}>
			<h1 style ={{color:"blue", display:"inline"}}> Welcome to Hexagon Board Tasks </h1>
			<h3 style ={{color:"blue", display:"inline"}}>(Drawing only version) </h3>
			
		</div>
		<hr />
		
		{/*Part 1 Exposition*/}
		{Part1Exposition}
		
				
		{/*Part 1 Info*/}
		
		<Accordion className="none" allowZeroExpanded={true} style={{display:"block"}}>
			<AccordionItem>
				<AccordionItemHeading>
					<AccordionItemButton>
						<b> Click here for expanded explanations </b>	 
					</AccordionItemButton>
				</AccordionItemHeading>
				<AccordionItemPanel>
					{Part1Content}
				</AccordionItemPanel>
			</AccordionItem>
		</Accordion>
		
		
	
	<p>
	<b> Note: </b>
	Do not refresh your browser at any stage, 
	otherwise you will have to resume the task.
	<br/><br/>
	Click the PRACTICE button to have some practice. 
	<br/>You are advised to take at least one practice task before taking the qualification test. 
	</p>
	<br/><br/>
	<StyledButton>
			<RedirectLink target ="_blank" to="/Practice">practice</RedirectLink>
		</StyledButton>	
	</Container>
)
}
export default VIntro;



const StyledButton = styled(Button)`
  width: 10%;
  float: ;
  margin-left: ;
`;

const RedirectLink = styled(Link)`
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0);
  padding: 20px 10px;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  transition: all 300ms;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;


